export enum BagsOfDifferentMaterialsFields {
  type = "type",
  length = "length",
  width = "width",
  folding = "folding",
  mainColor = "mainColor",
  numberOfPrintColorsFirstSide = "numberOfPrintColorsFirstSide",
  firstSidePrintArea = "firstSidePrintArea",
  numberOfPrintColorsSecondSide = "numberOfPrintColorsSecondSide",
  secondSidePrintArea = "secondSidePrintArea",
  designFile = "designFile",
  amountPcs = "amountPcs",
}
